var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var dashboardActions = require('../../../modules/dashboard/actions/dashboard');
var myqolScoresActions = require('../../../modules/dashboard/actions/get-myqol-scores');
var dashboardClickActions = require('../../../modules/meta/actions/dashboard-click');
var DashboardMyQol = require('../components/dashboardMyQol.jsx');

  var mapStateToProps = function(state, ownProps){
    return {
      auth: state.auth,
      dashboard: state.dashboard,
      latestScore: state.dashboard.myqolScores.latestScore,
      latestNonZeroScore: state.dashboard.myqolScores.latestNonZeroScore,
      id2ItemScoresData: state.dashboard.myqolScores.id2ItemScoresData
    };
  }

  var mapDispatchToProps = function(dispatch, ownProps) {
    return bindActionCreators(Object.assign({}, dashboardActions, myqolScoresActions, dashboardClickActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(DashboardMyQol);


// WEBPACK FOOTER //
// ./src/common/routes/dashboard/containers/dashboardMyQol.jsx